import styled from 'styled-components';

import { getVariant } from '@/themes/typographyUtilis';

export const FolderName = styled.p`
  margin: 40px 0 15px;
  ${getVariant({ variant: 'body2-bold' })}
  color: ${({ theme }) => theme.colors.primaryText};
`;
